import { type PlatformEvent } from '../types';

export const makeClickFavoriteEvent = (gameKey: string): PlatformEvent => {
  return {
    type: 'click',
    user_properties: {},
    event_properties: {
      game_key: gameKey,
      name: 'favorites',
    },
  };
};
